<template>
<div class="inpBox">
  <div class="detailsTitle">
    <h4>新建订单</h4>
    <div @click="back"><i class="fa fa-reply"></i></div>
  </div>
  <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline jiaoyan" label-width="120px" size="mini">
    <el-form-item label="结算客户 :" prop="payee" class="width1" label-width="120px">
      <el-select  v-model="goodform.payee" filterable placeholder="请选择" @change="jiesuanChange">
        <el-option v-for="item in kehuList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="外部单号:" label-width="120px" class="width1">
      <el-input  placeholder=""    maxlength="50" v-model="goodform.externalOrderNumber"  ></el-input>
    </el-form-item>
    <el-form-item label="项目名称:" prop="projectType"   label-width="120px"  class="width1">
      <el-select  v-model="goodform.projectType" filterable  placeholder="请选择">
        <el-option v-for="item in XMlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="销售合同:"  class="width1 jiage" label-width="120px">
      <el-input  placeholder="" class="disabled" :readonly="true"    maxlength="50" v-model="goodform.salesContract"  ></el-input>
       <el-button type="text" class="danwei" @click="xuanzeHT" style="margin-top: 8px;">选择</el-button>
    </el-form-item>
    <el-form-item label="合同结束日期:"  label-width="120px" class="width1" >
      <div style="width:260px">{{goodform.contractEndDate|dateFormat1}}</div>
    </el-form-item>
    <el-form-item label="合同提醒天数:" prop="contractReminderDays"  label-width="120px" class="width1" :rules="goodform.salesContract ? rules.contractReminderDays:[{required: false}]">
      <el-input  placeholder=""  maxlength="50"  v-number-input.float="0"  v-model="goodform.contractReminderDays"></el-input>
    </el-form-item>
     <el-form-item label="账期预警节点" prop="accountNodeSet"  class="width1" label-width="120px" >
      <el-select  v-model="goodform.accountNodeSet"  placeholder="请选择">
          <el-option  label="装船" value="0" ></el-option>
          <el-option  label="到港" value="1" ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="账期预警天数:" prop="accountReminderDays"  :rules="{ required: true, message: '请输入账期预警天数', trigger: 'blur' }"  label-width="120px" class="width1">
      <el-input  placeholder=""  maxlength="50" v-number-input.float="0"   v-model="goodform.accountReminderDays"></el-input>
    </el-form-item>
    <el-form-item label="业务部门:" prop="insuranceInfo"   label-width="120px" class="width1">
      <div style="width:260px">{{goodform.businessSubunit}}</div>
    </el-form-item>
    <el-form-item label="业务人员:" prop="businessUserId" label-width="120px" class="width1">
      <div v-if="ywyhFlag">{{goodform.businessUser}}</div>
      <el-select  v-else v-model="goodform.businessUserId" filterable placeholder="请选择" @change="yonghuChange">
        <el-option v-for="item in yonghuList" :label="item.userName" :value="item.userCode" :key="item.id"></el-option>
      </el-select>
    </el-form-item>
    <br>
    <el-form-item label="货物类型 :" prop="productType" label-width="120px" class="width1">
      <el-select  v-model="goodform.productType" filterable placeholder="请选择"  @change="HWLCchange">
        <el-option v-for="item in HWlist" :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="重量(吨):"  prop="weight" label-width="120px" class="width1" >
      <el-input  placeholder="" v-number-input.float="3" maxlength="8"  v-model="goodform.weight"
      class="width2"   @change="orderWeightFn($event,'吨')"></el-input>
    </el-form-item>
    <!-- <el-form-item label="业务人员:" prop="insuranceInfo"   >
      <div>{{goodform.businessUser}}</div>
    </el-form-item> -->

    <hr>
    <!-- 地址组件 -->
    <addDizhi :goodform="goodform" ></addDizhi>
    <hr>
    <shouru :goodform="goodform"></shouru>
    <hr>
    <uploadFiles :fileArr.sync='fileArr' :max=10 @remove="remove"></uploadFiles>
  </el-form>
  <div class="footerBtn">
    <el-button  class="bigBtn"  btnCode="004P001B001"  @click="back">取消</el-button>
    <el-button type="primary" class="bigBtn"  v-if="isEdit!=1"  @click="saveFn(1)">提交</el-button>
    <el-button type="primary" class="bigBtn"   v-if="isEdit!=1"  @click="saveFn(2)">复制建单</el-button>
    <el-button type="primary" class="bigBtn"   v-if="isEdit==1"  @click="XGsaveFn">提交</el-button>
  </div>
  <!-- 关联合同 -->
  <guanlianhetong :goodform="goodform" v-if="GLHTflag" :GLHTflag.sync='GLHTflag'></guanlianhetong>
</div>
</template>

<script>
import { selectTMSTenantListByCustom, getDepartmentUsers } from '@/api/newCrm'
import { getDictionaryDetailList, findCustomerInfoList, addOrder, getOrderInfo, updateOrder } from '@/api/newTMS'
import { cVLlist, cVTlist } from '@/api/vgs-driver2.0'
import addDizhi from '@/views/newTMS/publicFiles/wayAndOrder/addDizhi.vue'
import addGoodWaiku from '@/views/newTMS/publicFiles/wayAndOrder/addGoodWaiku.vue'
import uploadFiles from '@/views/newTMS/publicFiles/uploadFiles.vue'
import guanlianhetong from '@/views/newTMS/publicFiles/wayAndOrder/guanlianhetong.vue'
import shouru from '@/views/newTMS/publicFiles/wayAndOrder/shouru.vue'
import zhichu from '@/views/newTMS/publicFiles/wayAndOrder/zhichu.vue'
export default {
  components: {
    uploadFiles, guanlianhetong, shouru, addDizhi
  },
  data () {
    return {
      id: this.$route.query.id,
      isEdit: this.$route.query.isEdit,
      goodform: {
        goodsList: [],
        measuringUnit: '吨',
        incomePattern: '0',
        makeTicketYn: '是',
        ticketSystemYn: '否',
        revenueValuation: '0',
        urgencyFlag: 0
      },
      rules: {
        projectType: [
          { required: true, message: '请选择项目名称', trigger: 'blur' }
        ],
        payee: [
          { required: true, message: '请选择结算客户', trigger: 'blur' }
        ],
        orderBusinessType: [
          { required: true, message: '请选择业务类型', trigger: 'blur' }
        ],
        productType: [
          { required: true, message: '请选择货物类型', trigger: 'blur' }
        ],
        orderWeight: [
          { required: true, message: '请输入货量', trigger: 'blur' }
        ],
        arrivalTime: [
          { required: true, message: '请选择要求到达时间', trigger: 'blur' }
        ],
        businessUserId: [
          { required: true, message: '请选择业务人员', trigger: 'blur' }
        ],
        incomeUnitPrice: [
          { required: true, message: '请输入收入单价', trigger: 'blur' }
        ],
        incomeAmount: [
          { required: true, message: '请输入收入金额', trigger: 'blur' }
        ],
        pickupWarehouse: [
          { required: true, message: '请选择提货仓库', trigger: 'blur' }
        ],
        taxRate: [
          { required: true, message: '请输入收入税率', trigger: 'blur' }
        ],
        contractReminderDays: [
          { required: true, message: '请输入合同提醒天数', trigger: 'blur' }
        ],
        accountNodeSet: [
          { required: true, message: '请选择账期节点', trigger: 'blur' }
        ],
        weight: [
          { required: true, message: '请输入重量', trigger: 'blur' }
        ]
        // startDirection: [
        //   { required: true, message: '请输入起运港', trigger: 'blur' }
        // ],
        // endDirection: [
        //   { required: true, message: '请输入目的港', trigger: 'blur' }
        // ]
        // deliverPerson: [
        //   { required: true, message: '请输入发货人', trigger: 'blur' }
        // ],
        // deliverPhone: [
        //   { required: true, message: '请输入发货电话', trigger: 'blur' }
        // ],
        // deliverAddress: [
        //   { required: true, message: '请输入发货地址', trigger: 'blur' }
        // ],
        // receivingPerson: [
        //   { required: true, message: '请输入收货人', trigger: 'blur' }
        // ],
        // receivingPhone: [
        //   { required: true, message: '请输入收货电话', trigger: 'blur' }
        // ],
        // receivingAddress: [
        //   { required: true, message: '请输入收货地址', trigger: 'blur' }
        // ]
      },
      kehuList: [], // 结算客户
      YWLXlist: [], // 业务类型
      fileArr: [],
      GLHTflag: false, // 关联合同
      yonghuList: [],
      ywyhFlag: false, // 客户身上是否有业务用户
      HWlist: [],
      XMlist: [],
      tOrderBusiness: {},
      deleteAttachmentsIds: []
    }
  },
  created () {
    getDictionaryDetailList({ dictionaryType: 'business_type' }).then(res => { this.YWLXlist = res })
    getDictionaryDetailList({ dictionaryType: 'project_type' }).then(res => { this.XMlist = res })
    getDictionaryDetailList({ dictionaryType: 'goods_type' }).then(res => { this.HWlist = res })
    getDepartmentUsers({ subOrgCode: localStorage.getItem('orgSubCode'), bussinessUserFlag: 1 }).then(res => { this.yonghuList = res })
    if (this.id) { // 列表复制或修改按钮跳转过来
      getOrderInfo({ orderBusinessId: this.id }).then(res => {
        this.goodform = res.tOrder
        // this.$set(this.goodform, 'payee', res.tOrderBusiness.payee)
        if (this.isEdit != 1) {
          delete this.goodform.orderId
          delete this.goodform.id
          delete this.goodform.updateTime
          delete this.goodform.updateUser
          delete this.goodform.updateUserId
          delete this.goodform.createTime
          delete this.goodform.createUser
          delete this.goodform.createUserId
          delete this.goodform.accomplishedAmount
          this.$set(this.goodform, 'goodsList', [])
          this.$set(this.goodform, 'orderWeight', '')
          this.$set(this.goodform, 'weight', '')
          this.$set(this.goodform, 'volumn', '')
          this.$set(this.goodform, 'orderNumber', '')
        } else {
          this.tOrderBusiness = res.tOrderBusiness
        }

        this.$set(this.goodform, 'kilometres', res.tOrder.kilometres.toString())
        this.$set(this.goodform, 'orderBusinessType', res.tOrder.orderBusinessType.toString())
        this.$set(this.goodform, 'productType', res.tOrder.productType.toString())
        if (res.tOrderBusiness.incomePattern.toString()) {
          this.$set(this.goodform, 'incomePattern', res.tOrderBusiness.incomePattern.toString())
          this.$set(this.goodform, 'incomePatternName', res.tOrderBusiness.incomePatternName)
        }
        if (res.tOrderBusiness.revenueValuation.toString()) {
          this.$set(this.goodform, 'revenueValuation', res.tOrderBusiness.revenueValuation.toString())
          this.$set(this.goodform, 'revenueValuationName', res.tOrderBusiness.revenueValuationName)
        }
        this.$set(this.goodform, 'makeTicketYn', res.tOrderBusiness.makeTicketYn)
        this.$set(this.goodform, 'ticketSystemYn', res.tOrderBusiness.ticketSystemYn)
        this.$set(this.goodform, 'incomeUnitPrice', res.tOrderBusiness.incomeUnitPrice / 100)
        this.$set(this.goodform, 'incomeAmount', res.tOrderBusiness.incomeAmount / 100)
        this.$set(this.goodform, 'payee', res.tOrderBusiness.payee)
        this.$set(this.goodform, 'payeeTaxId', res.tOrderBusiness.payeeTaxId)
        this.$set(this.goodform, 'payeeCode', res.tOrderBusiness.payeeCode)
        this.$set(this.goodform, 'taxRate', res.tOrderBusiness.taxRate)
        this.goodform.settlementCustomersCode = res.tOrderBusiness.settlementCustomersCode
        // 判断业务用户是否可选
        findCustomerInfoList({ businessType: 1 }).then(res => {
          selectTMSTenantListByCustom(res).then(res1 => {
            this.kehuList = res1
            let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
            if (json[0].businessUserCode) {
              this.ywyhFlag = true
            } else {
              this.ywyhFlag = false
            }
          })
        })
      })
    } else {
      this.$set(this.goodform, 'taxRate', 9)
      this.$set(this.goodform, 'pickupWarehouse', '外库')
      this.$set(this.goodform, 'measuringUnit', '吨')
      this.$set(this.goodform, 'transportMode', 2)
      this.$set(this.goodform, 'kilometres', '0')

      findCustomerInfoList({ businessType: 1 }).then(res => {
        selectTMSTenantListByCustom(res).then(res1 => { this.kehuList = res1 })
      })
      this.$set(this.goodform, 'businessUnit', localStorage.getItem('orgName'))
      this.$set(this.goodform, 'businessUnitCode', localStorage.getItem('orgCode'))
      this.$set(this.goodform, 'businessSubunit', localStorage.getItem('orgSubName'))
      this.$set(this.goodform, 'businessSubunitCode', localStorage.getItem('orgSubCode'))
      this.$set(this.goodform, 'businessTenantCode', localStorage.getItem('tenantCode'))
      this.$set(this.goodform, 'businessTenantName', localStorage.getItem('tenantName'))
      this.$set(this.goodform, 'businessCompanyName', localStorage.getItem('companyName'))
      this.$set(this.goodform, 'businessCompanyCode', localStorage.getItem('companyCode'))
    }
  },
  mounted () {

  },
  methods: {
    // 删除文件
    remove (file) {
      if (file.id) {
        this.deleteAttachmentsIds.push(file.id)
      }
    },
    // 货物类型改变
    HWLCchange (e) {
      let json = this.HWlist.filter(item => item.itemNo == e)
      this.$set(this.goodform, 'productTypeName', json[0].showName)
    },
    // 货物重量改变
    orderWeightFn (e, danwei) {
      if (e != '' && Number(e) === 0) {
        this.$alert('输入的值不能为0', '系统提示')
        if (danwei == '吨') {
          this.$set(this.goodform, 'weight', '')
        } else if (danwei == '件') {
          this.$set(this.goodform, 'orderNumber', '')
        } else if (danwei == '方') {
          this.$set(this.goodform, 'volumn', '')
        }
      }
      this.orderWightFuzhi()
    },
    orderWightFuzhi () {
      if (this.goodform.measuringUnit == '吨') {
        this.$set(this.goodform, 'orderWeight', this.goodform.weight)
      } else if (this.goodform.measuringUnit == '件') {
        this.$set(this.goodform, 'orderWeight', this.goodform.orderNumber)
      } else if (this.goodform.measuringUnit == '方') {
        this.$set(this.goodform, 'orderWeight', this.goodform.volumn)
      }
    },
    SHYJchange () {
      let arr = [].concat(this.checkList)
      let n = this.checkList.indexOf('其他')
      if (n == -1) {
        this.qita = false
        this.addFrom.auditOpinion = arr.toString()
      } else {
        this.qita = true
        arr.splice(n, 1)
        this.addFrom.auditOpinion = arr.toString()
      }
    },
    // 选择用户
    yonghuChange (e) {
      let json = this.yonghuList.filter(item => item.userCode == e)
      this.$set(this.goodform, 'businessUser', json[0].userName)
    },
    // 选择结算客户
    jiesuanChange () {
      let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
      this.goodform.payCustomerId = json[0].id
      this.goodform.payeeTaxId = json[0].customerTaxId
      this.goodform.salesContract = ''
      this.goodform.periodDays = json[0].periodDays
      this.goodform.periodDaysType = json[0].periodDaysType
      if (json[0].businessUserCode) {
        this.ywyhFlag = true
        this.$set(this.goodform, 'businessUserId', json[0].businessUserCode)
        this.$set(this.goodform, 'businessUser', json[0].businessUserName)
      } else {
        this.ywyhFlag = false
        this.$set(this.goodform, 'businessUserId', null)
        this.$set(this.goodform, 'businessUser', null)
      }

      this.goodform.originalCustomer = this.goodform.payee// 下单客户
    },
    xuanzeHT () {
      if (this.goodform.payee) {
        let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
        this.goodform.payCustomerId = json[0].id
        this.GLHTflag = true
      } else {
        this.$alert('请先选择结算客户', '系统提示')
      }
    },
    saveFn (n) {
      if (!this.goodform.orderWeight) {
        this.$alert('订单量不能为0', '系统提示')
        return
      }
      let yewuleixingJson = this.YWLXlist.filter(item => item.itemNo == this.goodform.orderBusinessType)
      if (yewuleixingJson.length > 0) {
        this.goodform.orderBusinessTypeName = yewuleixingJson[0].showName
      } else {
        this.$set(this.goodform, 'orderBusinessType', null)
      }
      this.$refs.goodform.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
          if (json.length > 0) {
            this.goodform.payeeTaxId = json[0].customerTaxId
            this.goodform.settlementCustomersCode = json[0].tenantCode
          }

          let imgfile = new FormData()
          imgfile.append('params', JSON.stringify(this.goodform))
          this.fileArr.forEach(item => {
            imgfile.append('files', item.raw)
          })
          addOrder(imgfile).then(res => {
            loading.close()
            if (n == 1) {
              this.$router.push({ name: 'qiYunOrder' })
            } else {
              this.$set(this.goodform, 'goodsList', [])
              this.$set(this.goodform, 'weight', '')
              this.$set(this.goodform, 'orderWeight', '')
              this.$set(this.goodform, 'volumn', '')
              this.$set(this.goodform, 'orderNumber', '')
              this.fileArr = []
            }
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    XGsaveFn () {
      if (!this.goodform.orderWeight) {
        this.$alert('订单量不能为0', '系统提示')
        return
      }
      let yewuleixingJson = this.YWLXlist.filter(item => item.itemNo == this.goodform.orderBusinessType)
      if (yewuleixingJson.length > 0) {
        this.goodform.orderBusinessTypeName = yewuleixingJson[0].showName
      } else {
        this.$set(this.goodform, 'orderBusinessType', null)
      }

      this.$refs.goodform.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          let data = {}
          let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
          if (json && json.length > 0) {
            this.goodform.payeeTaxId = json[0].customerTaxId
            this.goodform.settlementCustomersCode = json[0].tenantCode
          }

          data.tOrder = this.goodform
          data.deleteOrderGoodsRelIds = []
          data.deleteAttachmentsIds = this.deleteAttachmentsIds
          data.goodslist = []
          data.tOrderBusiness = this.tOrderBusiness// 把业务实体整个赋值
          data.tOrderBusiness.payeeTaxId = this.goodform.payeeTaxId
          data.tOrderBusiness.payee = this.goodform.payee
          data.tOrderBusiness.incomePattern = this.goodform.incomePattern
          data.tOrderBusiness.makeTicketYn = this.goodform.makeTicketYn
          data.tOrderBusiness.ticketSystemYn = this.goodform.ticketSystemYn
          data.tOrderBusiness.revenueValuation = this.goodform.revenueValuation
          data.tOrderBusiness.incomePatternName = this.goodform.incomePatternName
          data.tOrderBusiness.revenueValuationName = this.goodform.revenueValuationName
          data.tOrderBusiness.incomeUnitPrice = this.goodform.incomeUnitPrice
          data.tOrderBusiness.incomeAmount = this.goodform.incomeAmount
          data.tOrderBusiness.expenditurePattern = this.goodform.expenditurePattern
          data.tOrderBusiness.freightPricingType = this.goodform.freightPricingType
          data.tOrderBusiness.expenditurePatternName = this.goodform.expenditurePatternName
          data.tOrderBusiness.freightPricingTypeName = this.goodform.freightPricingTypeName
          data.tOrderBusiness.freightUnitPrice = this.goodform.freightUnitPrice
          data.tOrderBusiness.freightAmount = this.goodform.freightAmount
          data.tOrderBusiness.serviceRate = this.goodform.serviceRate
          data.tOrderBusiness.serviceCharge = this.goodform.serviceCharge
          data.tOrderBusiness.freightTaxRate = this.goodform.freightTaxRate
          data.tOrderBusiness.taxRate = this.goodform.taxRate
          let imgfile = new FormData()
          imgfile.append('params', JSON.stringify(data))
          this.fileArr.forEach(item => {
            if (!item.id) {
              imgfile.append('files', item.raw)
            }
          })
          updateOrder(imgfile).then(res => {
            loading.close()
            this.$router.push({ name: 'qiYunOrder' })
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    back () {
      this.$router.go(-1)// 返回上一层
    }
  }
}
</script>

<style scoped lang='less'>
.width1  /deep/.el-input__inner{
  width: 260px;
}
.disabled /deep/.el-input__inner {
    background: #eff0f1;
}
hr{
  margin-bottom: 20px;
}
/deep/.remark .el-input .el-input__inner{
  width: 788px;
}
/deep/.jiaoyan .el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 14px 0 !important;
}
/deep/.el-range-editor{
  width: 430px;
}
</style>
